import { useMemo } from 'react'
import { useMyContext } from '../context/context'
import useSettingsV2 from './useSettingsV2'

const useConf = participation => {
  const { event } = useMyContext()
  const { settings } = useSettingsV2()

  const companionsMax = settings.FO_MEETING_COMPANIONS_MAX

  const showRepresentedBy = settings.FO_MEETING_SHOW_REPRESENTED_BY

  const showCompanions = settings.FO_MEETING_COMPANIONS_IS_ACTIVE

  const showConferences = settings.FO_MEETING_CONFERENCES_IS_ACTIVE
  const showConferencesV2 = settings.FO_MEETING_CONFERENCES_V2_IS_ACTIVE

  const showInfo2 = settings.FO_MEETING_INFO_2_IS_ACTIVE
  const info2 = settings.FO_MEETING_INFO_2_FORM_ID

  const articlesActive = settings.FO_MEETING_ARTICLES_IS_ACTIVE
  const articlesHide = settings.FO_MEETING_ARTICLES_AUTO

  const companyIndexLabel = settings.COMPANY_INDEX_LABEL
  const companyIndexSize = settings.COMPANY_INDEX_MAX_SIZE
  const companiesShow = settings.FO_MEETING_COMPANIES_SHOW
  const companiesFormId = settings.FO_MEETING_COMPANIES_FORM_ID

  const confirmationAccountId = settings.CONFIRMATION_ACCOUNT_ID
  const confirmationTemplateId = settings.CONFIRMATION_TEMPLATE_ID

  const showParticipation = !settings.FO_MEETING_PARTICIPATON_AUTO_REGISTER

  const HOME_HTML = settings.FO_MEETING_HOME

  const COMPANIES_INDEX_HTML = settings.FO_MEETING_COMPANIES_INDEX_HTML
  const COMPANIES_LABEL = settings.FO_MEETING_COMPANIES_LABEL

  const QUOTAS_SHOW = settings.FO_MEETING_QUOTAS_SHOW && (participation === 5 ? !settings.FO_MEETING_COMPANIONS_COPY_EXTENDED : true)

  const datesHide = event?.days.length < 2 || settings?.FO_MEETING_DATES_BY_PASS

  const formId = useMemo(() => {
    if (participation === 2) {
      return settings?.FO_MEETING_REPRESENTED_FORM || settings?.formId
    }

    if (participation === 5) {
      return settings.FO_MEETING_COMPANION_FORM_ID || settings.formId
    }

    return settings?.formId
  }, [participation, settings])

  const formV2Id = useMemo(() => {
    if (participation === 2) {
      return settings.FO_MEETING_INFORMATIONS_FORM_ID
    }

    if (participation === 5) {
      return settings.FO_MEETING_COMPANION_2_FORM_ID
    }

    return settings.FO_MEETING_INFORMATIONS_FORM_ID
  }, [participation, settings])

  const showSection = id => settings[`SECTION_${id}_SHOW`]

  const confOr = key => {
    return settings[key]
  }

  return {
    ...settings,
    showCompanions,
    companionsMax,
    showRepresentedBy,
    showConferences,
    formId,
    articlesActive,
    articlesHide,
    confirmationTemplateId,
    confirmationAccountId,
    showInfo2,
    info2,
    companyIndexLabel,
    companyIndexSize,
    companiesShow,
    companiesFormId,
    showParticipation,
    showSection,
    HOME_HTML,
    COMPANIES_INDEX_HTML,
    COMPANIES_LABEL,
    QUOTAS_SHOW,
    confOr,
    datesHide,
    showConferencesV2,
    formV2Id,
    settings,
  }
}

export default useConf
